import React from "react"
import styles from 'src/css/info_page.module.css'
import {graphql} from 'gatsby'
import Layout from 'src/components/layout'
import RichText from 'src/components/rich_text'
import {getPageData} from 'src/utilities/data'
import {classes} from 'src/utilities/classes'
import Markdown from 'src/components/markdown'
import DynamicStyle from 'src/components/dynamic_style'
import SEO from 'src/components/seo'
import { InfoPageSEO, Link, Menu, SiteSettings, SiteBanner } from 'src/queries'

const InfoPage = getPageData(({pageData, menuData, siteBannerData, siteSettings, pageContext}) => {
  const { header_color, header_image, heading, heading_color, content, content_color, content_markdown } = pageData
  return (
    <Layout pageContext={pageContext} menuData={menuData} siteBannerData={siteBannerData} siteSettings={siteSettings}>
      <SEO {...pageData} lang={pageContext.lang} />
      <DynamicStyle className={styles.wrapper} dynamicStyle={{
        backgroundImage: header_image ? `url(${header_image.url})` : undefined
      }} />
      <div className={classes(styles.wrapper, !header_image && styles[header_color])}>
        <div className={styles.content}>
          <RichText className={styles.heading} style={{color: heading_color}}>{heading}</RichText>
          <RichText style={{color: content_color}}>{content}</RichText>
          <Markdown style={{color: content_color}}>{content_markdown}</Markdown>
        </div>
      </div>
    </Layout>
  )
})
InfoPage.fragments = [Link, InfoPageSEO, Menu, SiteSettings, SiteBanner]
export default InfoPage

export const query = graphql`
  query($uid: String, $lang: String) {
    prismic {
      allInfo_pages(uid: $uid, lang: $lang) {
        edges {
          node {
            header_color
            header_image
            heading
            heading_color
            content
            content_color
            content_markdown
            ...InfoPageSEO
          }
        }
      }
      allMenus(lang: $lang) { ...Menu }
      allSite_settingss(lang: $lang) { ...SiteSettings }
      allSite_banners(lang: $lang) { ...SiteBanner }
    }
  }
`